import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Box } from "@mui/material";
import CustomTooltip from "../customTooltip";

const createCustomLegend = (legendItems, isMobile) => {
  const legendContainer = document.getElementById("recharts-custom-legend");
  if (!legendContainer) return;

  legendContainer.innerHTML = ""; // Clear previous legend

  legendItems.forEach((item, index) => {
    if (!isMobile && index % 13 === 0) {
      const columnDiv = document.createElement("div");
      columnDiv.classList.add("legend-column");
      legendContainer.appendChild(columnDiv);
    }

    const legendItem = document.createElement("div");
    legendItem.classList.add("legend-item");

    const legendColorBox = document.createElement("span");
    legendColorBox.classList.add("legend-color-box");
    legendColorBox.style.backgroundColor = item.color;

    const legendText = document.createElement("span");
    legendText.classList.add("legend-text");
    legendText.innerText = item.value;

    legendItem.appendChild(legendColorBox);
    legendItem.appendChild(legendText);

    if (isMobile) {
      legendContainer.appendChild(legendItem);
    } else {
      const columns = legendContainer.getElementsByClassName("legend-column");
      columns[columns.length - 1].appendChild(legendItem);
    }
  });
};

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const capitalizeLabels = (labels) => {
  return labels.map((label) => capitalizeFirstLetter(label));
};

const PieChartComponent = ({ chartColors, numbers, labels, title }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    if (typeof window !== "undefined") {
      handleResize(); // Set initial value
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  useEffect(() => {
    const legendItems = labels.map((label, index) => ({
      value: capitalizeFirstLetter(label),
      color: Object.values(chartColors)[index],
    }));
    createCustomLegend(legendItems, isMobile);
  }, [isMobile]);

  const capitalizedLabels = capitalizeLabels(labels);

  const data = capitalizedLabels.map((label, index) => ({
    name: label,
    value: numbers[index],
    fill: Object.values(chartColors)[index],
  }));

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
          flexDirection: "column",
        },
      })}
    >
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={150}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} stroke="none" strokeWidth={0} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend content={<CustomLegend legendItems={labels.map((label, index) => ({
            value: capitalizeFirstLetter(label),
            color: Object.values(chartColors)[index],
          }))} isMobile={isMobile} />} />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

const CustomLegend = ({ legendItems, isMobile }) => {
  useEffect(() => {
    createCustomLegend(legendItems, isMobile);
  }, [legendItems, isMobile]);

  return <div id="recharts-custom-legend" className="custom-legend"></div>;
};

export default PieChartComponent;



